import { normalize } from 'styled-normalize';

import { buttonReset, listReset, textNormal } from './mixins';
import { createGlobalStyle, type ThemeProps } from './styled';

export const GlobalStyles = createGlobalStyle<ThemeProps>`
    ${normalize}

    * {
			box-sizing: border-box;
    }

    html {
			font-family: 'Arial', 'Helvetica', sans-serif;
			font-size: 16px;
			width: 100%;
			height: 100%;
			margin: 0;
			padding: 0;
    }

    body {
			width: 100%;
			height: 100%;
			margin: 0;
			padding: 0;
			background-color: ${({ theme }) => theme.colors.backgroundColorLight};
			${textNormal()};
    }

    a,
    a:active,
    a:hover,
    a:visited {
			text-decoration: none;
    }

    button {
      ${buttonReset()};
    }

    h1, h2, h3, h4, h5, h6, p {
			padding: 0;
			margin: 0;
    }

    ${listReset()};

    // Fix blurry image in chrome
    @media screen and (-webkit-min-device-pixel-ratio:0) and (min-resolution:.001dpcm) {
			img {
				image-rendering: -webkit-optimize-contrast !important;
			}
    }

  /* Safari-specific styles */
  @media (-webkit-min-device-pixel-ratio: 0) and (min-resolution: .001dpcm) {
    /* Reset styles to maintain consistency */
    html, body {
      border: 0;
      vertical-align: baseline;
      -webkit-font-smoothing: antialiased; /* Smooths fonts at the pixel level for better visual perception */
      text-rendering: optimizeLegibility; /* Enhances text readability, especially during animations */
      text-size-adjust: 100%; /* Prevents font scaling at the pixel level for better visual perception */
    }
  }

  /* iPhone-specific button text color fix */
  @media screen and (-webkit-min-device-pixel-ratio: 2), screen and (min-resolution: 2dppx) {
    body {
      padding-top: constant(safe-area-inset-top); /* Fallback for older iOS versions */
      padding-top: env(safe-area-inset-top); /* Newer CSS function for safe areas */
    }

    button {
      color: var(--THEME-BTN-TEXT);
    }
  }

  /* Style adjustments for handling viewport issues on iOS Safari */
  @supports (-webkit-touch-callout: none) {
    html, body {
      height: 100%;
      width: 100%;
    }
  }
`;
